import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProfileCompletionCard = ({ completionPercentage, missingItems }) => {
  const navigate = useNavigate();

  const handleCompleteProfile = () => {
    navigate('/user-profile-settings');
  };

  return (
    <div className="bg-gradient-to-br from-primary/10 to-accent/10 border border-primary/20 rounded-lg p-6">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Complete Your Profile</h3>
          <p className="text-sm text-muted-foreground">
            {completionPercentage}% completed
          </p>
        </div>
        <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center">
          <Icon name="User" size={24} color="var(--color-primary)" />
        </div>
      </div>
      <div className="w-full bg-muted rounded-full h-2 mb-4">
        <div 
          className="bg-primary h-2 rounded-full transition-all duration-500"
          style={{ width: `${completionPercentage}%` }}
        />
      </div>
      <div className="space-y-2 mb-4">
        {missingItems?.map((item, index) => (
          <div key={index} className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="AlertCircle" size={16} className="text-warning" />
            <span>{item}</span>
          </div>
        ))}
      </div>
      <Button 
        variant="default" 
        fullWidth
        iconName="ArrowRight"
        iconPosition="right"
        onClick={handleCompleteProfile}
      >
        Complete Profile
      </Button>
    </div>
  );
};

export default ProfileCompletionCard;